import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { DemoAssetMediaModel } from "../../core/model/ContentManagement";

@Component({
  selector: "brd-demo-tile-image",
  templateUrl: "./demo-tile-image.component.html",
  styleUrl: "./demo-tile-image.component.less",
  standalone: false
})
export class DemoTileImageComponent {
  @Input() mediaModel$!: Observable<DemoAssetMediaModel | null>;
  @Input() containerHover!: boolean;

  public constructor() {}

  getImgSrc(mediaModel: DemoAssetMediaModel): string {
    const { defaultImage, hoverImage } = mediaModel ?? { defaultImage: "" };

    if (this.containerHover) return hoverImage ? hoverImage : defaultImage;
    else return defaultImage;
  }
}
